import React, { useContext } from 'react';
import { useAccount } from 'wagmi';
import ConnectWalletButton from '../../components/connectWallet/ConnectWalletButton';
import SwitchNetworkButton from '../../components/connectWallet/SwitchNetworkButton';
import {
    CPGAddress,
    targetChainId,
    WalletAddressContext,
} from '../../constant/constant';

const AdminOnlyPage = ({ title, description, children }) => {
    const { isAdmin } = useContext(WalletAddressContext);
    const { isConnected, chainId } = useAccount();

    if (!isConnected) {
        return (
            <div className="crypto-page flex min-h-[calc(100vh-80px)] flex-col items-center justify-center px-4 py-16 text-center">
                <h1 className="text-2xl font-semibold text-zinc-900 dark:text-white">
                    {title}
                </h1>
                <p className="mt-2 max-w-md text-sm text-zinc-600 dark:text-zinc-400">
                    Connect the on-chain contract admin wallet to view this page.
                </p>
                <div className="mt-8">
                    <ConnectWalletButton />
                </div>
            </div>
        );
    }

    if (chainId !== targetChainId) {
        return (
            <div className="crypto-page flex min-h-[calc(100vh-80px)] flex-col items-center justify-center px-4 py-16 text-center">
                <h1 className="text-2xl font-semibold text-zinc-900 dark:text-white">
                    Wrong network
                </h1>
                <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-400">
                    Switch to the configured chain to load contract analytics.
                </p>
                <div className="mt-6">
                    <SwitchNetworkButton />
                </div>
            </div>
        );
    }

    if (!isAdmin) {
        return (
            <div className="crypto-page flex min-h-[calc(100vh-80px)] flex-col items-center justify-center px-4 py-16 text-center">
                <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl border border-amber-200 bg-amber-50 dark:border-amber-900/50 dark:bg-amber-950/40">
                    <i className="fa-solid fa-lock text-xl text-amber-700 dark:text-amber-400" />
                </div>
                <h1 className="text-2xl font-semibold text-zinc-900 dark:text-white">
                    Admin access required
                </h1>
                <p className="mt-2 max-w-md text-sm text-zinc-600 dark:text-zinc-400">
                    {description ||
                        'Only the gateway contract admin wallet can open this page.'}
                </p>
                {CPGAddress && (
                    <p className="mt-4 font-mono text-xs text-zinc-500 dark:text-zinc-500">
                        Gateway admin is read from the deployed CPG contract.
                    </p>
                )}
            </div>
        );
    }

    return children;
};

export default AdminOnlyPage;
